export default "__VITE_ASSET__DdtRIxJd__"